// extracted by mini-css-extract-plugin
module.exports = {"container":"Expired_container__1Urgo","title":"Expired_title__3dMIh","description":"Expired_description__2O2_a"};